// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./SearchIcon.data";

export const SearchIcon = createIcon("SearchIcon", iconNode);
